/**
 * UNIT-SIZE-TOOLTITS
 * Display number of users for one unit
 */
import Space from "@/components/space"
import Tooltip from "@/components/tooltip"
import { faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface Props {
  size: number | null
  position?: "top" | "bottom" | "left" | "right" | null
}

export default function UnitSizeTooltip(props: Props) {
  const displayValue = props.size || "NC"
  return (
    <Tooltip
      text={`Nombre de personnes concernées: ${displayValue}`}
      position={props.position ?? undefined}
      className="flex grey-t ml-10 w-[60px] text-sm my-auto">
      <FontAwesomeIcon icon={faUser} className="m-auto mr-1" />
      {displayValue}
      <Space />
    </Tooltip>
  )
}
